const envs = {
  dev: {
    Monthly: [
      {
        primaryHeader: 'MaverickApp Pro',
        name: 'proV2',
        id: 'price_1KDwqNBQ2V0NM2d5Q6n9XiFi',
        price: 298,
      },
      {
        primaryHeader: 'AutoPilot',
        name: 'autoPilot',
        id: 'price_1KDwwvBQ2V0NM2d5ikGUShSv',
        price: 498,
      },
      {
        primaryHeader: 'AutoPilot Top Gun',
        name: 'autoPilot',
        id: 'price_1KDwxvBQ2V0NM2d5VMIHIiYO',
        price: 798,
      },
    ],
    Yearly: [
      {
        primaryHeader: 'MaverickApp Pro',
        name: 'proV2',
        id: 'price_1IvSYKBQ2V0NM2d5Af6yWvNQ',
        price: 225,
        stripeDescription: `when you pre-pay $${225 *12} for 12 months`,
      },
      {
        primaryHeader: 'AutoPilot',
        name: 'autoPilot',
        id: 'price_1KDwwvBQ2V0NM2d5JLh3ZBqs',
        price: 425,
        stripeDescription: `when you pre-pay $${425 *12} for 12 months`,
      },
      {
        primaryHeader: 'AutoPilot Top Gun',
        name: 'autoPilot',
        id: 'price_1KDwqNBQ2V0NM2d5RVFDY4mJ',
        price: 725,
        stripeDescription: `when you pre-pay $${725 *12} for 12 months`,
      },
    ],
  },
  prod: {
    Monthly: [
      {
        primaryHeader: 'MaverickApp Pro',
        name: 'proV2',
        id: 'price_1KEjiSBQ2V0NM2d5Oh4NDvc1',
        price: 298,
      },
      {
        primaryHeader: 'AutoPilot',
        name: 'autoPilot',
        id: 'price_1KEjiLBQ2V0NM2d5NwRpnWUe',
        price: 498,
      },
      {
        primaryHeader: 'AutoPilot Top Gun',
        name: 'autoPilot',
        id: 'price_1KEjiFBQ2V0NM2d5VggHySGD',
        price: 798,
      },
    ],
    Yearly: [
      {
        primaryHeader: 'MaverickApp Pro',
        id: 'price_1KEjiSBQ2V0NM2d5rbJy2kI5',
        price: 225,
        stripeDescription: `when you pre-pay $${225 *12} for 12 months`,
      },
      {
        primaryHeader: 'AutoPilot',
        id: 'price_1KEjiLBQ2V0NM2d52K4dPjSL',
        price: 425,
        stripeDescription: `when you pre-pay $${425 *12} for 12 months`,
      },
      {
        primaryHeader: 'AutoPilot Top Gun',
        name: 'autoPilot',
        id: 'price_1KEjiFBQ2V0NM2d5CjVd4UT2',
        price: 725,
        stripeDescription: `when you pre-pay $${725 *12} for 12 months`,
      },
    ],
  },
};
const dev = {
  apiGateway: {
    REGION: 'us-east-1',
    URL: 'https://2rv87dit7f.execute-api.us-east-1.amazonaws.com/dev',
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_rVPxshF63',
    APP_CLIENT_ID: '2mt9kuno8lgu5k1n96u0vpqi2t',
    IDENTITY_POOL_ID: 'us-east-1:ead22611-2679-49fc-b3d4-34bde9dd61d6',
  },
  STRIPE_PUBLIC_KEY: 'pk_test_IrZZOy1gEHHQQtrdryXO66IN001RozEI0L',
  STRIPE_V2: { ...envs.dev },
};
const prod = {
  apiGateway: {
    REGION: 'us-east-1',
    URL: 'https://7knkcdvuj6.execute-api.us-east-1.amazonaws.com/beta',
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_WL8xPR6TO',
    APP_CLIENT_ID: '2qhvl5kpe4tc7v20stt0smel2h',
    IDENTITY_POOL_ID: 'us-east-1:1f69ba5d-00cc-4abd-a533-2e49408bec69',
  },
  STRIPE_PUBLIC_KEY: 'pk_live_QpjmYsQ9wLIwQMzaaGbtVbRZ007x3HGTbl',
  STRIPE_V2: { ...envs.prod },
};
// Default to dev if not set
const getConfig = () => {
  switch (process.env.REACT_APP_STAGE) {
    case 'prod':
      // eslint-disable-next-line no-console
      console.log = () => {};
      return prod;
    case 'dev':
      return dev;
    default:
      // eslint-disable-next-line no-console
      console.log = () => {};
      return prod;
  }
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // Add common config values here
  ...getConfig(),
};
